module.exports = __webpack_public_path__ + "static/media/merriweather-bold-webfont.b6b7444f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-bold-webfont.woff
// module id = 296
// module chunks = 0